<div [style.width]="width()" class="skeleton"></div>
